export const whoisCorne = `
#### How would you describe yourself?
I'm Corne Gabriels, 50 years old, living with MODY-type diabetes for 25 years.
In daily life, I work as a data architect and I'm a passionate data enthusiast. I'm driven to use data not only in business but also to help manage and improve health.
<br />
<br />  

#### Can you tell us something special about you that not so many people know?
I love camping, and for the past 12 years, my partner and I have been caring for our wonderful foster daughter.
<br />
<br />  

#### What were the biggest challenges you faced before using a closed-loop system?
I didn't face many challenges, but my biggest issue is my severe insulin resistance. Managing that properly remains a key challenge, even with the closed-loop system.
<br />
<br />  

#### Can you tell us about your diabetes journey and what led you to open-source looping?
I've been living with diabetes for about 25 years. Early on, it became clear I had an unusual form of the condition with extreme insulin resistance. There's still uncertainty about the exact type — because I'm not slim, I was quickly labeled as type 2.

But after trying everything from weight loss and intensive exercise to intravenous insulin therapy, it turned out that reversing diabetes through lifestyle alone wasn't the solution for me.

After trying many different approaches, my new pump supplier recommended I explore Looping — and that turned out to be a workable and effective option.
<br />
<br />  

#### What are the biggest benefits you've experienced with open-source looping?
The biggest benefits have been a significant improvement in both my HbA1c and my overall quality of life.
<br />
<br />  

#### Have you faced any major issues with your open source loop setup? How did you solve them?
I haven't experienced major issues, mainly because I'm an experienced IT professional and have been very hands-on with managing my own diabetes for many years.
<br />
<br />  

#### What's your advice for someone struggling with their open source loop settings?
Start slowly, take small steps, and make sure to carefully read the open-source looping documentation.
 
Don't try to set everything up all at once — manage your expectations and adjust them as you go.
<br />  
<br />  

#### Where do you see the future of diabetes over 10 years?
I see two major directions:
- The development of cell growth technologies to regenerate insulin-producing cells
- The digital pancreas — combining AI with increasingly compact and efficient hardware
<br />
<br />  

<!-- blog-contact-footer -->
`;
